import React, { useState, useEffect } from 'react'
import styles from './HeroFeature.module.scss'
import { Modal } from '../../../../common/components/modal/Modal'

interface HeroFeatureProps {
  title: string
  description: string
  image?: string
  desktopImage?: string
  mobileImage?: string
  bulletPoints?: string[]
  reversed?: boolean
  clientImages?: {
    desktopLight: string
    desktopDark: string
    mobileLight: string
    mobileDark: string
  }[] // массив картинок для разных клиентов
  theme?: 'light' | 'dark'
}

export const HeroFeature: React.FC<HeroFeatureProps> = ({
  title,
  description,
  image,
  desktopImage,
  mobileImage,
  bulletPoints,
  reversed = false,
  clientImages,
  theme = 'light',
}) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null)
  const [currentDesktop, setCurrentDesktop] = useState(desktopImage)
  const [currentMobile, setCurrentMobile] = useState(mobileImage)

  // Рандомайзинг при монтировании
  useEffect(() => {
    if (clientImages && clientImages.length > 0) {
      const randomIndex = Math.floor(Math.random() * clientImages.length)
      const randomClient = clientImages[randomIndex]

      setCurrentDesktop(theme === 'light' ? randomClient.desktopLight : randomClient.desktopDark)
      setCurrentMobile(theme === 'light' ? randomClient.mobileLight : randomClient.mobileDark)
    }
  }, [clientImages, theme])

  const handleImageClick = (img: string) => {
    setSelectedImage(img)
  }

  return (
    <>
      <div className={`${styles.container} ${reversed ? styles.reversed : ''}`}>
        <div className={styles.imagesWrapper}>
          {image && (
            <img
              src={image}
              alt={title}
              className={styles.singleImage}
              onClick={() => handleImageClick(image)}
              style={{ cursor: 'pointer' }}
            />
          )}
          {currentDesktop && currentMobile && (
            <>
              <img
                src={currentDesktop}
                alt="Десктоп версия"
                className={styles.desktopImage}
                onClick={() => handleImageClick(currentDesktop)}
                style={{ cursor: 'pointer' }}
              />
              <img
                src={currentMobile}
                alt="Мобильная версия"
                className={styles.mobileImage}
                onClick={() => handleImageClick(currentMobile)}
                style={{ cursor: 'pointer' }}
              />
            </>
          )}
        </div>
        <div className={styles.content}>
          <h3 className={styles.title}>{title}</h3>
          <p className={styles.description}>{description}</p>
          {bulletPoints && bulletPoints.length > 0 && (
            <ul className={styles.list}>
              {bulletPoints.map((point, idx) => (
                <li key={idx}>{point}</li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* Модалка с картинкой */}
      <Modal
        modalActive={!!selectedImage}
        setModalActive={() => setSelectedImage(null)}
        image={true}
      >
        {selectedImage ? (
          <img
            src={selectedImage}
            alt={title}
            style={{
              maxWidth: '90vw',
              maxHeight: '90vh',
              objectFit: 'contain',
            }}
          />
        ) : (
          <></>
        )}
      </Modal>
    </>
  )
}
